<template>
  <StrokeButton plain size="middle" type="primary" @click="getCSV">
    {{ $t('EXPORT_CSV') }}
  </StrokeButton>
</template>

<script>
import { BasicAdsCampaigns } from '@/api/api';
import FileSaver from 'file-saver';
import StrokeButton from '../../common/StrokeButton';

export default {
  name: 'CampaignStatsOverallCSVButton',
  components: {
    StrokeButton,
  },
  props: {
    range: {
      type: String,
      required: true,
    },
    campaignId: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    getCSV() {
      return BasicAdsCampaigns.saveCSV(this.campaignId, this.range)
        .then(file => {
          FileSaver.saveAs(file, file.name);
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
  },
};
</script>
